import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import '@shared/ui/tokens.css';
import './brand/theme.css';
import App from './App';
import { AuthProvider } from './contexts/AuthContext';
import { AnalysisTypeProvider } from './contexts/AnalysisTypeContext';
import configureAmplify from './aws-config';
import MetaPixelService from './services/metaPixel';
import { captureAttribution } from './utils/attribution';
import { BrandProvider } from '@shared/ui/brand';
import { ShellProvider } from '@shared/ui/shell';
import { TourProvider } from '@shared/ui/tour';
import { MaintenanceGate } from '@shared/ui/maintenance/Maintenance';
import { GRAPHQL_URL } from './apollo/client';
import { brand } from './brand/brand';
import { shell } from './brand/shell';

// Load analytics test in development
if (import.meta.env.DEV) {
  import('./test-analytics');
}

// Configure AWS Amplify
console.log('Configuring AWS Amplify...');
configureAmplify();
console.log('AWS Amplify configuration complete');

// Initialize Meta Pixel
console.log('Initializing Meta Pixel...');
MetaPixelService.init();
console.log('Meta Pixel initialization complete');

// Capture marketing attribution (UTMs, click IDs, referrer) for this visit
captureAttribution();

// Render the application immediately
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AuthProvider>
      <AnalysisTypeProvider>
        <BrandProvider brand={brand}>
          <MaintenanceGate apiUrl={GRAPHQL_URL}>
            <ShellProvider shell={shell}>
              <TourProvider>
                <App />
              </TourProvider>
            </ShellProvider>
          </MaintenanceGate>
        </BrandProvider>
      </AnalysisTypeProvider>
    </AuthProvider>
  </React.StrictMode>
);
console.log('Application rendered');
